import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieConsentBanner } from './components/CookieConsent';
import { Home } from './pages/Home';
import { Leistungen } from './pages/Leistungen';
import { UeberUns } from './pages/UeberUns';
import { Kontakt } from './pages/Kontakt';
import { Jobs } from './pages/Jobs';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function AppContent() {
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  const location = useLocation();

  // Check for cookie-settings query param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('cookie-settings') === 'true') {
      setShowCookieSettings(true);
    }
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1" role="main">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </main>
      <Footer onOpenCookieSettings={() => setShowCookieSettings(true)} />
      <CookieConsentBanner 
        forceOpen={showCookieSettings} 
        onClose={() => setShowCookieSettings(false)}
      />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
